import { useMemo } from "react";
import { useTheme } from "src/hooks";
import { type ICol } from "src/interfaces";
import { generateHeaders } from "../../../generator/PortraitOrientation/PortraitSection/PortraitSectionHeaders/generateHeaders";

interface Props {
  headers: ICol[];
  sIndex: number;
  headerSize?: string;
  horizontalScroll?: boolean;
  entryIndex?: number;
  offset?: number;
  pdfEntry?: boolean;
}

const Header = ({
  headers,
  sIndex,
  headerSize,
  horizontalScroll,
  entryIndex,
  offset,
  pdfEntry,
}: Props) => {
  const theme = useTheme() as any;

  const generatedHeaders = useMemo(
    () =>
      generateHeaders({
        headers,
        theme,
        headerSize,
        headerRef: null,
        sectionIndex: sIndex,
        NMEAButton: false,
        summary: true,
        omitThead: true,
        entryIndex,
        pdfEntry,
      }),
    [headers, theme, headerSize, pdfEntry],
  );
  return (
    <thead
      style={
        !horizontalScroll
          ? {
              position: "sticky",
              top: `calc(-3px + ${offset ?? 0}px)`,
              width: "100%",
              zIndex: 4,
            }
          : {}
      }>
      {generatedHeaders}
    </thead>
  );
};

export default Header;
